<div class="text-center">
  <img src="assets/img/undraw_no_data_qbuo.svg" class="img-fluid"
       alt="iSupplier no preview" style="width: 35rem;"/>
  <h4 class="mb-4" *ngIf="message">{{message}}</h4>
</div>
